import { IConfig } from '@cian/config/shared';
import { IErrorResponseSchema } from 'shared/common/repositories/geo-suggest/entities/schemas/ErrorResponseSchema';
import { IV1GetClustersForMapResponseSchema } from 'shared/common/repositories/search-offers-index/entities/get_clusters_for_map/V1GetClustersForMapResponseSchema';

import { mapFetchClustersResponse, mapFetchClustersResponseError } from './mappers';
import { ERentTime, getTermValue, TJsonQuery } from '../../../common/packages/JsonQuery';
import {
  IGetClustersForMapOptions,
  TGetClustersForMapResponse,
  TGetClustersForMapRequest,
  TGetClustersForMapModel,
  createGetClustersForMapModel as createGetClustersForMapModelOriginal,
} from '../../../common/repositories/search-offers-index/v1/get-clusters-for-map';
import { fetchGetClustersForMap as fetchGetClustersForMapOld } from '../../../common/repositories/search-offers-map/v1/get-clusters-for-map';
import { IApplicationContext } from '../../types/applicationContext';
import { withJobName } from '../../utils/withJobName';

type TOptions = Omit<
  IGetClustersForMapOptions<IV1GetClustersForMapResponseSchema, IErrorResponseSchema>,
  'httpApi' | 'mappers'
>;

export async function fetchGetClustersForMap(context: IApplicationContext, options: TOptions) {
  const { config, httpApi } = context;
  const { jsonQuery } = options.parameters;
  const rentalPeriod = getTermValue('for_day')(jsonQuery as TJsonQuery);
  const isDailyRent = rentalPeriod === ERentTime.Daily;

  // TODO выпилить тоггл в задаче https://jira.cian.tech/browse/CD-183563
  if (isDailyRent || !config.get<boolean>('map-search-frontend.fetchClusters.next')) {
    return fetchGetClustersForMapOld({
      ...options,
      httpApi,
      mappers: {
        200: mapFetchClustersResponse,
        400: mapFetchClustersResponseError,
      },
    });
  }

  const result = await httpApi.fetch(createGetClustersForMapModel(context.config, options.parameters), options.config);

  if (result.statusCode === 200) {
    return mapFetchClustersResponse(result.response as IV1GetClustersForMapResponseSchema);
  }

  if (result.statusCode === 400) {
    return mapFetchClustersResponseError(result.response as IErrorResponseSchema);
  }

  return {
    statusCode: result.statusCode,
    response: result.response,
    headers: result.headers,
  } as TGetClustersForMapResponse;
}

function createGetClustersForMapModel(config: IConfig, parameters: TGetClustersForMapRequest): TGetClustersForMapModel {
  const requestConfig = createGetClustersForMapModelOriginal(parameters);

  return withJobName(config, requestConfig);
}
